// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__qtJLm","colMin":"styles_colMin__bQItY"};